import { render } from "./InputLabel.vue?vue&type=template&id=d6ca4656"
import script from "./InputLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./InputLabel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/InputLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6ca4656"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6ca4656', __exports__)) {
    api.reload('d6ca4656', __exports__)
  }
  
  module.hot.accept("./InputLabel.vue?vue&type=template&id=d6ca4656", () => {
    api.rerender('d6ca4656', render)
  })

}


export default __exports__